(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('home', {
      parent: 'app',
      url: '/home',
      views: {
        'content@': {
          templateUrl: 'components/home/home.html',
          controller: 'HomeController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    });
  }
})();
